




import { removeTag } from '@/modules/util/RemoveTag'
import { Component, Prop, Vue } from 'vue-property-decorator'

/**
 * HTMLタグから許可したタグ以外を除外して表示する
 */
@Component
export default class RemoveTag extends Vue {
  @Prop() private text!: string
  @Prop({ required: false, default: () => ['sup', 'sub'] })
  private arrowTags!: string[]

  /**
   * HTMLタグを除去する
   */
  get stripTags(): string {
    return removeTag(this.text, this.arrowTags)
  }
}
